/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import { Twitter, Facebook, Reddit, Mail } from 'react-social-sharing';

import './Sharing.css';


class Sharing extends Component {

  render() {
    let url = this.props.url;
    let message = this.props.message;

    return (
      <div className="Sharing">
        <Facebook solid small link={url} />
        <Twitter solid small link={url} message={message} />
        <Reddit solid small link={url} />
        <Mail solid small link={url} subject={message} />
      </div>
    )
  }
}

export default Sharing;



/** WEBPACK FOOTER **
 ** ./src/components/partials/Sharing.js
 **/